// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
const QG_REQUEST_PAGE_DATA = 'QG_REQUEST_PAGE_DATA';
const QG_REQUEST_PAGE_DATA_SUCCESS = 'QG_REQUEST_PAGE_DATA_SUCCESS';

export {
  QG_REQUEST_PAGE_DATA,
  QG_REQUEST_PAGE_DATA_SUCCESS,
};
